type Props = {
  readonly className?: string;
};

function MatcherSearchFoundIcon({ className }: Props) {
  return (
    <svg
      width="96"
      height="96"
      viewBox="0 0 96 96"
      className={className}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g filter="url(#filter0_g_4900_51229)">
        <path
          d="M42.2624 51.2235L45.8428 47.9638C46.4262 47.4326 47.3333 47.4892 47.8461 48.0887L50.4231 51.1012C50.9255 51.6886 50.8559 52.5723 50.2676 53.0737L46.9089 55.9367C44.0955 59.0615 37.9128 66.2594 35.6898 70.0523C32.911 74.7935 29.8235 77.9183 26.8388 78.8881C23.8542 79.8579 21.7958 77.4873 20.8696 76.4098C19.9433 75.3322 19.841 74.7935 19.5322 72.7462C19.2235 70.6989 23.8544 65.0957 27.4565 61.7553C30.3132 59.1062 38.3287 53.7675 42.0773 51.3657C42.1438 51.3231 42.204 51.2766 42.2624 51.2235Z"
          fill="#00B2F6"
        />
      </g>
      <g filter="url(#filter1_g_4900_51229)">
        <path
          d="M79.4113 38.967C79.4113 49.4249 70.6692 57.9028 59.8853 57.9028C45.5004 57.9028 40.3594 49.4249 40.3594 38.967C40.3594 28.5091 49.1014 20.0312 59.8853 20.0312C70.6692 20.0312 79.4113 28.5091 79.4113 38.967Z"
          fill="#00B2F6"
        />
      </g>
      <g filter="url(#filter2_g_4900_51229)">
        <path
          d="M69.0735 43.8638C65.8255 47.8809 60.1008 50.577 54.8355 48.2178"
          stroke="#003561"
          strokeWidth="2.79567"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <g filter="url(#filter3_g_4900_51229)">
        <path
          d="M37.4121 51.4961C39.0166 51.5905 41.6596 52.346 42.3209 55.6506"
          stroke="#003561"
          strokeWidth="3"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <g filter="url(#filter4_g_4900_51229)">
        <path
          d="M38.555 50.7384L41.915 47.8167C42.5336 47.2787 43.4696 47.3371 44.0166 47.9478L46.2526 50.4444C46.8238 51.0821 46.7462 52.0678 46.0822 52.6083L43.0304 55.093C40.3144 57.9742 34.3459 64.611 32.1999 68.1082C29.5174 72.4798 26.5368 75.361 23.6555 76.2552C20.7743 77.1494 18.7872 74.9636 17.8931 73.9701C16.9989 72.9765 16.9001 72.4798 16.602 70.5921C16.304 68.7044 20.7745 63.538 24.2518 60.4581C27.0069 58.0178 34.7323 53.1025 38.3555 50.8848C38.4269 50.8412 38.4919 50.7933 38.555 50.7384Z"
          stroke="#003561"
          strokeWidth="3"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <g filter="url(#filter5_g_4900_51229)">
        <circle
          cx="58.4162"
          cy="35.8205"
          r="18.9358"
          stroke="#003561"
          strokeWidth="3"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <filter
          id="filter0_g_4900_51229"
          x="19.1681"
          y="47.2502"
          width="31.9392"
          height="32.2155"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="BackgroundImageFix"
            result="shape"
          />
          <feTurbulence
            type="fractalNoise"
            baseFrequency="0.4769274890422821 0.4769274890422821"
            numOctaves={3}
            seed={275}
          />
          <feDisplacementMap
            in="shape"
            scale="0.69891828298568726"
            xChannelSelector="R"
            yChannelSelector="G"
            result="displacedImage"
            width="100%"
            height="100%"
          />
          <feMerge result="effect1_texture_4900_51229">
            <feMergeNode in="displacedImage" />
          </feMerge>
        </filter>
        <filter
          id="filter1_g_4900_51229"
          x="40.0099"
          y="19.6818"
          width="39.7517"
          height="38.57"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="BackgroundImageFix"
            result="shape"
          />
          <feTurbulence
            type="fractalNoise"
            baseFrequency="0.4769274890422821 0.4769274890422821"
            numOctaves={3}
            seed={275}
          />
          <feDisplacementMap
            in="shape"
            scale="0.69891828298568726"
            xChannelSelector="R"
            yChannelSelector="G"
            result="displacedImage"
            width="100%"
            height="100%"
          />
          <feMerge result="effect1_texture_4900_51229">
            <feMergeNode in="displacedImage" />
          </feMerge>
        </filter>
        <filter
          id="filter2_g_4900_51229"
          x="53.088"
          y="42.1164"
          width="17.7321"
          height="8.73505"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="BackgroundImageFix"
            result="shape"
          />
          <feTurbulence
            type="fractalNoise"
            baseFrequency="0.4769274890422821 0.4769274890422821"
            numOctaves={3}
            seed={275}
          />
          <feDisplacementMap
            in="shape"
            scale="0.69891828298568726"
            xChannelSelector="R"
            yChannelSelector="G"
            result="displacedImage"
            width="100%"
            height="100%"
          />
          <feMerge result="effect1_texture_4900_51229">
            <feMergeNode in="displacedImage" />
          </feMerge>
        </filter>
        <filter
          id="filter3_g_4900_51229"
          x="35.5371"
          y="49.6211"
          width="8.6582"
          height="7.90527"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="BackgroundImageFix"
            result="shape"
          />
          <feTurbulence
            type="fractalNoise"
            baseFrequency="0.4444444477558136 0.4444444477558136"
            numOctaves={3}
            seed={275}
          />
          <feDisplacementMap
            in="shape"
            scale="0.75"
            xChannelSelector="R"
            yChannelSelector="G"
            result="displacedImage"
            width="100%"
            height="100%"
          />
          <feMerge result="effect1_texture_4900_51229">
            <feMergeNode in="displacedImage" />
          </feMerge>
        </filter>
        <filter
          id="filter4_g_4900_51229"
          x="14.7129"
          y="45.5732"
          width="33.7969"
          height="32.7705"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="BackgroundImageFix"
            result="shape"
          />
          <feTurbulence
            type="fractalNoise"
            baseFrequency="0.4444444477558136 0.4444444477558136"
            numOctaves={3}
            seed={275}
          />
          <feDisplacementMap
            in="shape"
            scale="0.75"
            xChannelSelector="R"
            yChannelSelector="G"
            result="displacedImage"
            width="100%"
            height="100%"
          />
          <feMerge result="effect1_texture_4900_51229">
            <feMergeNode in="displacedImage" />
          </feMerge>
        </filter>
        <filter
          id="filter5_g_4900_51229"
          x="37.6055"
          y="15.0098"
          width="41.6211"
          height="41.6211"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="BackgroundImageFix"
            result="shape"
          />
          <feTurbulence
            type="fractalNoise"
            baseFrequency="0.4444444477558136 0.4444444477558136"
            numOctaves={3}
            seed={275}
          />
          <feDisplacementMap
            in="shape"
            scale="0.75"
            xChannelSelector="R"
            yChannelSelector="G"
            result="displacedImage"
            width="100%"
            height="100%"
          />
          <feMerge result="effect1_texture_4900_51229">
            <feMergeNode in="displacedImage" />
          </feMerge>
        </filter>
      </defs>
    </svg>
  );
}

export { MatcherSearchFoundIcon };
